import { Procedure, SurgeonProcedure } from "../../../../../types/procedures";
import { Surgeon } from "../../../../../types/surgeons";
import {
  MODIFIER_AGE_OVER_50,
  MODIFIER_LOST_MORE_THAN_50,
  MODIFIER_MEDICAL_CONDITION,
  MODIFIER_PRIOR_COSMETIC_SURGERY,
  MODIFIER_SMOKE,
  useQuote,
} from "../../../QuoteProvider";

type GetSurgeonPriceRangeProps = {
  selectedSurgeon: Surgeon;
};

export function useGetSurgeonPriceRange({
  selectedSurgeon,
}: GetSurgeonPriceRangeProps) {
  const { selectedProcedures } = useQuote();

  const totalProcedurePrice =
    selectedProcedures.reduce((accumulator, procedure: Procedure) => {
      const surgeonPrice: SurgeonProcedure | undefined = procedure.prices?.find(
        (price: any) => {
          if (!price.surgeon) return false;

          return price.surgeon.id === selectedSurgeon.id;
        }
      );

      const price = surgeonPrice ? surgeonPrice.price : 0;

      return accumulator + price;
    }, 0) + selectedSurgeon.basePrice;

  const maxPrice =
    totalProcedurePrice +
    totalProcedurePrice * MODIFIER_AGE_OVER_50 +
    totalProcedurePrice * MODIFIER_LOST_MORE_THAN_50 +
    totalProcedurePrice * MODIFIER_MEDICAL_CONDITION +
    totalProcedurePrice * MODIFIER_PRIOR_COSMETIC_SURGERY +
    totalProcedurePrice * MODIFIER_SMOKE;

  return {
    approximate: totalProcedurePrice + totalProcedurePrice * 0.15,
    minPrice: totalProcedurePrice,
    maxPrice,
  };
}
